import type { FC } from "react";

import { classes, Icon, Text } from "@alpacahq/ui/old";

export type FromToItem = {
  imgSrc?: string;
  name: string;
  account: string;
};

type FromAndToProps = {
  from: FromToItem;
  to: FromToItem;
  className?: string;
};

export const FromTo: FC<FromAndToProps> = ({ from, to, className }) => (
  <div className={className}>
    {[from, to].map((item, index) => (
      <div key={item.name} className={classes(index === 0 && "mb-4")}>
        <Text className="pb-1">
          {index === 0 ? "Transfer From" : "Transfer To"}:
        </Text>
        <div className="flex min-h-16 items-center justify-start gap-4 rounded-md border border-gray-200 px-4 py-2">
          {item.imgSrc ? (
            <img
              className="h-[40px] w-[40px]"
              src={item.imgSrc}
              alt={`${item.name} logo`}
            />
          ) : (
            <Icon name="BuildingLibrary" size="xl" className="h-10 w-10" />
          )}
          <Text>
            <span className="font-semibold">{item.name}</span>{" "}
            <span>({item.account})</span>
          </Text>
        </div>
      </div>
    ))}
  </div>
);
